<template>
  <g>
    <g clip-path="url(#clip0_15_674)">
      <path
        d="M18.5 0.000244141H4.5C3.12 0.000244141 2 1.12024 2 2.50024V21.5002C2 22.8802 3.12 24.0002 4.5 24.0002H18.5C19.88 24.0002 21 22.8802 21 21.5002V2.50024C21 1.12024 19.88 0.000244141 18.5 0.000244141ZM11.5 23.0002C10.67 23.0002 10 22.3302 10 21.5002C10 20.6702 10.67 20.0002 11.5 20.0002C12.33 20.0002 13 20.6702 13 21.5002C13 22.3302 12.33 23.0002 11.5 23.0002ZM19 19.0002H4V3.00024H19V19.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_674">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
